module.exports = __webpack_public_path__ + "img/table_2.7cc0e1d1.webp";